module.exports = __webpack_public_path__ + "static/media/remote-icon.b5c9741b.svg";